export default __webpack_public_path__ + "static/media/money-back.fe6892b7.png";